import { makePostRequest } from "../api/requests";

const makeServiceRequest = async (func, params) => {
  const reqBody = { 
    func, params };
  return makePostRequest(reqBody, "rt/portal");
};

const ObjectInputService = {
  getObjectInput: (id) =>
    makeServiceRequest("getObjectInputWithFullTree", { id }),
  updateObjectInput: (data) => makeServiceRequest("updateObject", data),
  getFileUploadURL: (data) => makeServiceRequest("requestFileUploadURL", data),
  getTempFileConfirmed: (id) =>
    makeServiceRequest("isTmpSavedFileObjectConfirmed", { id }),
  saveFileObject: (id) => makeServiceRequest("saveFileObject", { id }),
  getFileDownlaodURL: (data) =>
    makeServiceRequest("requestFileDownloadURL", data),
};

export default ObjectInputService;
